import React from 'react'
import { Menu } from 'antd'
import classNames from 'classnames'
import { NavLink } from 'react-router-dom'
import { useSelector } from 'react-redux'
import _ from 'lodash'
import style from '../appNavMenu/style.module.scss'
import AppNavCategoryHeader from '../appNavCategoryHeader'

const AgentConfigMenu = ({
  activeTab,
  appID,
  agentUid,
  openKeys,
  onOpenChange,
  onSelect,
  // selectedKeys, // this will require when we keep active based on  selectedKeys.
}) => {
  const apps = useSelector(state => state.apps)
  const { activeBuilderAgent } = apps

  // Use the active builder agent UID if available, fallback to agentUid prop
  const currentAgentUid = activeBuilderAgent?.uid || agentUid

  return (
    <>
      <AppNavCategoryHeader
        name={activeBuilderAgent?.name && activeBuilderAgent.name.toUpperCase()}
      />
      <Menu
        className={style.appNavMenuCustom}
        mode="inline"
        openKeys={openKeys}
        onOpenChange={onOpenChange}
        onSelect={onSelect}
        // selectedKeys={selectedKeys}
      >
        <Menu.Item
          className={classNames(
            style.appNavMenuCustomItem,
            _.includes(`/app/${appID}/ai-agents/${currentAgentUid}/instructions`, activeTab) ||
              _.includes(activeTab, `/app/${appID}/ai-agents/${currentAgentUid}/instructions`)
              ? style.appNavItemSelected
              : '',
          )}
          key="agent-instructions"
        >
          <NavLink
            to={`/app/${appID}/ai-agents/${currentAgentUid}/instructions`}
            style={{ marginBottom: '0px' }}
            exact
          >
            <div className={style.appNavLinkWrapper}>
              <div
                className={classNames(
                  style.appNavMenuIcon,
                  style.appNavMenuIconInstructions,
                  '__menu__item__icon',
                )}
              />
              <span>Instructions</span>
            </div>
          </NavLink>
        </Menu.Item>

        <Menu.Item
          className={classNames(
            style.appNavMenuCustomItem,
            _.includes(`/app/${appID}/ai-agents/${currentAgentUid}/tool`, activeTab) ||
              _.includes(activeTab, `/app/${appID}/ai-agents/${currentAgentUid}/tool`)
              ? style.appNavItemSelected
              : '',
          )}
          key="agent-tool"
        >
          <NavLink
            to={`/app/${appID}/ai-agents/${currentAgentUid}/tool`}
            style={{ marginBottom: '0px' }}
            exact
          >
            <div className={style.appNavLinkWrapper}>
              <div
                className={classNames(
                  style.appNavMenuIcon,
                  style.appNavMenuIconTool,
                  '__menu__item__icon',
                )}
              />
              <span>Tools</span>
            </div>
          </NavLink>
        </Menu.Item>

        <Menu.Item
          className={classNames(
            style.appNavMenuCustomItem,
            _.includes(`/app/${appID}/ai-agents/${currentAgentUid}/mcp`, activeTab) ||
              _.includes(activeTab, `/app/${appID}/ai-agents/${currentAgentUid}/mcp`)
              ? style.appNavItemSelected
              : '',
          )}
          key="agent-mcp"
        >
          <NavLink
            to={`/app/${appID}/ai-agents/${currentAgentUid}/mcp`}
            style={{ marginBottom: '0px' }}
            exact
          >
            <div className={style.appNavLinkWrapper}>
              <div
                className={classNames(
                  style.appNavMenuIcon,
                  style.appNavMenuIconMCPConfig,
                  '__menu__item__icon',
                )}
              />
              <span>MCP</span>
            </div>
          </NavLink>
        </Menu.Item>

        <Menu.Item
          className={classNames(
            style.appNavMenuCustomItem,
            _.includes(`/app/${appID}/ai-agents/${currentAgentUid}/knowledge-base`, activeTab) ||
              _.includes(activeTab, `/app/${appID}/ai-agents/${currentAgentUid}/knowledge-base`) ||
              _.includes(activeTab, `knowledge-base`)
              ? style.appNavItemSelected
              : '',
          )}
          key="agent-knowledge-base"
        >
          <NavLink
            to={`/app/${appID}/ai-agents/${currentAgentUid}/knowledge-base`}
            style={{ marginBottom: '0px' }}
            exact
          >
            <div className={style.appNavLinkWrapper}>
              <div
                className={classNames(
                  style.appNavMenuIcon,
                  style.appNavMenuIconKnowledgeBase,
                  '__menu__item__icon',
                )}
              />
              <span>Knowledge Base</span>
            </div>
          </NavLink>
        </Menu.Item>

        <Menu.Item
          className={classNames(
            style.appNavMenuCustomItem,
            _.includes(`/app/${appID}/ai-agents/${currentAgentUid}/logs`, activeTab) ||
              _.includes(activeTab, `/app/${appID}/ai-agents/${currentAgentUid}/logs`)
              ? style.appNavItemSelected
              : '',
          )}
          key="agent-logs"
        >
          <NavLink
            to={`/app/${appID}/ai-agents/${currentAgentUid}/logs`}
            style={{ marginBottom: '0px' }}
            exact
          >
            <div className={style.appNavLinkWrapper}>
              <div
                className={classNames(
                  style.appNavMenuIcon,
                  style.appNavMenuIconLogs || '',
                  '__menu__item__icon',
                )}
              />
              <span>Logs</span>
            </div>
          </NavLink>
        </Menu.Item>

        <Menu.Item
          className={classNames(
            style.appNavMenuCustomItem,
            _.includes(`/app/${appID}/ai-agents/${currentAgentUid}/deploy`, activeTab) ||
              _.includes(activeTab, `/app/${appID}/ai-agents/${currentAgentUid}/deploy`)
              ? style.appNavItemSelected
              : '',
          )}
          key="agent-deploy"
        >
          <NavLink
            to={`/app/${appID}/ai-agents/${currentAgentUid}/deploy`}
            style={{ marginBottom: '0px' }}
            exact
          >
            <div className={style.appNavLinkWrapper}>
              <div
                className={classNames(
                  style.appNavMenuIcon,
                  style.appNavMenuIconDeploy,
                  '__menu__item__icon',
                )}
              />
              <span>Deploy</span>
            </div>
          </NavLink>
        </Menu.Item>
      </Menu>
    </>
  )
}

export default AgentConfigMenu
